// extracted by mini-css-extract-plugin
export default {"display-1":"form_display-1__6veAg","white":"form_white__kEeWB","form":"form_form__0rTJG","field":"form_field__47Hq1","submit":"form_submit__QWmJt"};